/* eslint-disable no-new */
/*-----------------------------------------------
|                    iasc Offcanvas
-----------------------------------------------*/

const iascOffcanvasInit = () => {
  const { getData } = window.iasc.utils;
  const toggleEls = document.querySelectorAll(
    "[data-iasc-toggle='offcanvas']"
  );
  const offcanvasBackdrop = document.querySelector('[data-iasc-backdrop]');

  const showFilterCol = offcanvasEl => {
    offcanvasEl.classList.add('show');
    document.body.style.overflow = 'hidden';
  };
  const hideFilterCol = offcanvasEl => {
    offcanvasEl.classList.remove('show');
    document.body.style.removeProperty('overflow');
  };

  if (toggleEls) {
    toggleEls.forEach(toggleEl => {
      const offcanvasTarget = getData(toggleEl, 'iasc-target');
      const offcanvasTargetEl = document.querySelector(offcanvasTarget);
      const closeBtn = offcanvasTargetEl.querySelector(
        "[data-iasc-dismiss='offcanvas']"
      );

      toggleEl.addEventListener('click', () => {
        console.log({ offcanvasTargetEl });
        showFilterCol(offcanvasTargetEl);
      });
      if (closeBtn) {
        closeBtn.addEventListener('click', () => {
          hideFilterCol(offcanvasTargetEl);
        });
      }
      if (offcanvasBackdrop) {
        offcanvasBackdrop.addEventListener('click', () => {
          hideFilterCol(offcanvasTargetEl);
        });
      }
    });
  }
};

export default iascOffcanvasInit;
